export function initLocataireFields() {
  return {
    id: "",
    nom: "",
    prenom: "",
    email: "",
    telephone: "",
  };
}

export function initGarantFields() {
  return {
    id: "",
    nom: "",
    prenom: "",
    email: "",
    telephone: "",
    ville: "",
    code_postal: "",
    adresse: "",
  };
}